export default {"src":"/_next/static/media/success-circle-green.f4cfeca6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};